export function tenantGreetingName(tenant) {
  const firstPerson = String(tenant || '')
    .split(',')[0]
    .trim();
  const first = firstPerson.split(/\s+/)[0];
  return first || 'Tenant';
}

export function notifyToLabel({ tenant, property } = {}) {
  const name = String(tenant || 'Unknown Tenant').trim();
  const addr = String(property || '').trim();
  return addr ? `${name} — ${addr}` : name;
}

function displayAmount(amount) {
  const raw = String(amount ?? '').trim();
  if (!raw) return '$0';
  return raw.startsWith('$') || raw.startsWith('-$') ? raw : `$${raw}`;
}

export function buildUncollectedNotifyMarkdown({
  tenant,
  amount,
  balance,
  ledgerUrl,
  balanceOnly,
} = {}) {
  const firstName = tenantGreetingName(tenant);
  const rent = displayAmount(amount);
  const bal = displayAmount(balance ?? amount);
  const url = ledgerUrl || 'https://tenantapp.bigtapapp.com/?d=ledger';
  const opening = balanceOnly
    ? `You are currently carrying a balance of **${bal}**.`
    : `Your rent payment of **${rent}** has not been received by the deadline. You are currently carrying a balance of **${bal}**.`;
  return `Dear ${firstName},

${opening}

You can see your current ledger using the one-time link below; or if you sign up to use the new tenant app at https://tenantapp.bigtapapp.com you can view it at any time.

[click here to see your ledger](${url})

To avoid late charges and eviction escalation, please bring your account up to date immediately, or advise us of your payment plans via email to communications@bigpropertymanagement.com.

**The Big Property Management Team**`;
}
